import { Component, OnInit } from '@angular/core';
import { ApiService } from './handlers/apiHandler.service';
import { HttpErrorResponse, HttpUrlEncodingCodec } from '@angular/common/http';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment.dev';
import { Environment } from 'src/environments/environment';
import { LoggerService } from './handlers/logger.service';

@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html'
})

/**
 * The Main AppComponent is the main healthchecker of the angular webpage.
 * Seeing that the angular site will always connect to the ABCis APIs,
 * There is no reason for a user to be on the site if the api's fails.
 */
export class AppComponent implements OnInit{

  loadMain: boolean = false;
  loadError: boolean = false;
  errorCode: HttpErrorResponse = null;


  constructor(
    private apiService : ApiService,
    private router: Router,
    private translate: TranslateService,
    private logger: LoggerService) { }

  ngOnInit(): void {
    console.log(`Environment: ${(this.GetEnvironmentString(environment.status.toString()))}`);

    this.HealthCheck();
    this.loadMain = false;

    // this language will be used as a fallback when a translation isn't found in the current language
    this.translate.setDefaultLang('en');

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    this.translate.use('en');
  }

  GetEnvironmentString(str: string) {
    switch (str) {
    case '0':
      return 'Development';

    case '1':
      return 'Staging';

    case '2':
      return 'Production';
    }
  }

  /**
   * Health check will simply check the apistatus and either
   * show the main site if it works, Or an error page if it fails
   */
  HealthCheck() {
    const apistatus = this.apiService.GetUrlConfigurations();
    this.logger.ngOnInit();
    apistatus.then((status: any) => {
      this.setMain();
    }).catch((error: HttpErrorResponse) => {
      this.SetError(error);
    });
  }

  /**
   * Show the main website page
   */
  setMain() {
    if(this.loadError == false) {
      this.loadMain = true;
    }
  }

  /**
   * Shows the amazing error page
   * @param code The http error code
   */
  SetError(code: HttpErrorResponse) {
    this.router.navigateByUrl('/error');
    this.loadMain = false;
    this.loadError = true;
    this.errorCode = code;
  }
}
